module.exports = __webpack_public_path__ + "img/irisaco.e412318.png";